import React, { FC } from 'react';
import { SVGProps } from '@utils';
import { SvgWrapper } from './SvgWrapper';

interface PrevNextButtonProps extends SVGProps {
  isNext?: boolean;
}

export const PrevNextButton: FC<PrevNextButtonProps> = ({ onClick, divClassName, isNext = false }) => (
  <SvgWrapper
    divClassName={divClassName}
    onClick={onClick}
  >
    <svg 
      style={{ transform: `rotateY(${isNext ? 180 : 0}deg)`}}
      width="6"
      height="14" 
      viewBox="0 0 6 14" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        id="Vector" 
        d="M5.18454e-07 7L6 13.5L6 0.5L5.18454e-07 7Z" 
        fill="#434649" 
        fillOpacity="0.85"
      />
    </svg>
  </SvgWrapper>
);
